export default class ScrollTo {
    constructor($link) {
        this.$link = $link;
        this.scrollTo = this.scrollTo.bind(this);

        if($link.getAttribute('href') !== '#' && document.querySelector($link.getAttribute('href'))) {
            $link.addEventListener('click', this.scrollTo)
        }
    }

    scrollTo(e) {
        e.preventDefault();
        document.querySelector(this.$link.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    }
}